<div class="reactivate-dialog-container">
  <div class="reactivate-dialog-content">
    <div class="reactivate-icon-wrapper">
      <div class="reactivate-icon">🎉</div>
    </div>
    
    <h2 class="reactivate-title">¡Bienvenido de vuelta!</h2>
    <p class="reactivate-subtitle">Nos alegra que vuelvas. Tu suscripción se reactivará inmediatamente y podrás seguir disfrutando de todas las funcionalidades sin interrupciones.</p>

    <div class="reactivate-benefits">
      <h3 class="benefits-title">Al reactivar tu cuenta:</h3>
      <div class="benefit-list">
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Acceso inmediato a todas las funcionalidades</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Continúa desde donde lo dejaste</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Sin pérdida de datos ni configuración</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Facturación desde hoy mismo</span>
        </div>
      </div>
    </div>

    <div class="reactivate-actions">
      <button type="button" class="btn btn-reactivate" (click)="onConfirmReactivate()">
        <span class="btn-icon">✨</span>
        Sí, reactivar mi cuenta
      </button>
      <button type="button" class="btn btn-cancel" (click)="onCancel()">
        Cancelar
      </button>
    </div>

    <p class="reactivate-footer">
      ¿Tienes dudas? <a href="mailto:soporte@handly.es" class="support-link">Escríbenos</a>
    </p>
  </div>
</div>
